import { render, staticRenderFns } from "./WorkflowTransitionActionDetailFormDialog.vue?vue&type=template&id=e79f6a6e&"
import script from "./WorkflowTransitionActionDetailFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransitionActionDetailFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports